import { useId } from 'react';

import { useTheme } from '@mui/material';

import { AI_BRAND_STOPS } from '@/utils/aiBrandGradient';

export type InkSparkleIconProps = {
  /** Rendered width/height in px (the icon is square). */
  size?: number;
  className?: string;
};

export const InkSparkleIcon = ({
  size = 36,
  className,
}: InkSparkleIconProps) => {
  const theme = useTheme();
  // Unique gradient id so multiple instances on a page don't share <defs>.
  const gradientId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30.5478 29.6589"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M20.2125 9.81269C17.9538 7.54724 16.4331 1.85514 16.4331 1.85514C15.2319 -0.618316 14.7783 -0.618368 13.5341 1.85492C13.5341 1.85492 11.6027 8.00088 9.75677 9.81269C7.91081 11.6245 1.93799 13.451 1.93799 13.451C-0.645228 14.3519 -0.647108 15.7129 1.93901 16.35C1.93901 16.35 7.35965 17.836 9.75677 20.2684C12.1024 22.6485 13.5351 27.9459 13.5351 27.9459C14.3251 30.2296 15.6863 30.2296 16.4341 27.9459C16.4341 27.9459 17.8669 22.6485 20.2125 20.2684C22.6095 17.8361 28.03 16.35 28.03 16.35C30.6567 15.7129 30.6567 14.3519 28.03 13.451C28.03 13.451 22.4711 12.0781 20.2125 9.81269Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M24.9943 1.11066L24.3412 2.55737L22.8945 3.21046C22.5721 3.35926 22.5721 3.81394 22.8945 3.96275L24.3412 4.61583L24.9943 6.07081C25.1431 6.39322 25.5978 6.39322 25.7466 6.07081L26.3997 4.6241L27.8547 3.97101C28.1771 3.82221 28.1771 3.36753 27.8547 3.21872L26.408 2.56564L25.7549 1.11066C25.6061 0.788245 25.1431 0.788245 24.9943 1.11066Z"
        fill={theme.palette.lightBlue400}
      />
      <path
        d="M22.6676 16.6383L21.1255 20.0542L17.7096 21.5962C16.9484 21.9476 16.9484 23.0212 17.7096 23.3725L21.1255 24.9145L22.6676 28.35C23.0189 29.1112 24.0925 29.1112 24.4438 28.35L25.9859 24.9341L29.4213 23.392C30.1826 23.0407 30.1826 21.9671 29.4213 21.6157L26.0054 20.0737L24.4634 16.6383C24.112 15.877 23.0189 15.877 22.6676 16.6383Z"
        fill={theme.palette.purpleA200}
        stroke={theme.palette.neutral00}
        strokeWidth={1.11111}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="29.6567"
          y2="29.998"
          gradientUnits="userSpaceOnUse"
        >
          {AI_BRAND_STOPS.map((s) => (
            <stop key={s.hex} offset={s.offset} stopColor={s.hex} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  );
};
